// 图标注册表：名字 → lucide 组件。后台用名字选择，前端按名字渲染。
import {
  Cpu, BookOpen, Building2, Hand, WifiOff, Code2, School, Phone, Mail, MapPin,
  Clock, Radio, Palette, CircleDot, Heart, Wrench, Package, GraduationCap,
  RefreshCw, Users, Sparkles, Lightbulb, Rocket, Star, Gamepad2, ShieldCheck,
  FlaskConical, Workflow, TrendingUp,
} from 'lucide-react';

export const ICONS = {
  Cpu, BookOpen, Building2, Hand, WifiOff, Code2, School, Phone, Mail, MapPin,
  Clock, Radio, Palette, CircleDot, Heart, Wrench, Package, GraduationCap,
  RefreshCw, Users, Sparkles, Lightbulb, Rocket, Star, Gamepad2, ShieldCheck,
  FlaskConical, Workflow, TrendingUp,
};

// 后台下拉可选的图标名
export const ICON_NAMES = Object.keys(ICONS);

// 安全取图标组件，找不到用 Sparkles 兜底
export function getIcon(name) {
  return ICONS[name] || Sparkles;
}